import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withState, withHandlers } from 'recompose';
import { PAGE_TYPES } from '@sparefoot/tracking-events';
import { mapDispatchToActions } from '@sparefoot/react-core/utils';
import { getStaticViewPixel } from '@sparefoot/react-core/utils/tracking';

import { submitContactForm } from 'store/modules/pages';
import contactSelector from 'store/selectors/contact';

import { Page, Section, Container, Group } from 'components/core/Page';
import { H1, Paragraph } from 'components/core/Typography';
import { ContactForm } from 'components/email/ContactForm';

import './ContactPage.scss';
import { withPageViewTracking } from 'components/core/library/tracking-utils';

export const enhance = compose(
	connect(contactSelector, { submitContactForm }, mapDispatchToActions),
	withState('formSubmitted', 'setFormSubmitted', false),
	withHandlers({
		onSuccess:
			({ setFormSubmitted }) =>
			(payload) => {
				setFormSubmitted(true);
				return payload;
			},
	}),
	withPageViewTracking(PAGE_TYPES.CONTACT),
);

export function ContactPage({
	canonical,
	formSubmitted,
	actions,
	onSuccess,
	recaptchaSiteKey,
}) {
	return (
		<Page
			className="contact-page"
			trackingPixel={getStaticViewPixel()}
			pageType={PAGE_TYPES.CONTACT}
			title="SelfStorage.com: Find Cheap Storage Units Near You"
			canonical={canonical}
		>
			<Section>
				{!formSubmitted && (
					<Container>
						<H1 size="large">Contact SelfStorage.com</H1>
						<Group>
							<Paragraph>
								If you have a question, complete the form below
								and we'll get in touch with you!
							</Paragraph>
						</Group>
						<ContactForm
							onSubmit={actions.submitContactForm}
							onSuccess={onSuccess}
							recaptchaSiteKey={recaptchaSiteKey}
						/>
					</Container>
				)}
				{formSubmitted && (
					<Container>
						<H1 size="large">
							Thank you for contacting SelfStorage.com.
						</H1>
						<Paragraph>
							We will be in touch with you soon.
						</Paragraph>
					</Container>
				)}
			</Section>
		</Page>
	);
}

ContactPage.propTypes = {
	canonical: PropTypes.string.isRequired,
	formSubmitted: PropTypes.bool.isRequired,
	onSuccess: PropTypes.func.isRequired,
	recaptchaSiteKey: PropTypes.string.isRequired,
	actions: PropTypes.shape({
		submitContactForm: PropTypes.func.isRequired,
	}),
};

export default enhance(ContactPage);
